import { LangMap } from '@pyg-services/language/language.types';

export enum META_TRANSLATIONS {
  '' = 'default',
  'blog' = 'blog',
  'futureoftelco' = 'fot',
  'pygmalios-for-frontline-teams' = 'pygx',
  'privacy-policy' = 'pp',
  'virtual-queue' = 'vq',
  'museums' = 'museums',
  'customer-journey-analytics-and-service-monitoring-with-tdi' = 'tdi',
  'in-store-analytics' = 'products',
  'solutions' = 'solutions',
  'innovation' = 'innovation',
  'platform' = 'platform',
  'case-studies' = 'case_studies',
  'about' = 'about',
  'contact_us' = 'contact',
  'industries/retail' = 'industry_retail',
  'industries/malls' = 'industry_malls',
  'industries/telecom-banking' = 'industry_telecom_banking',
  'industries/forecourt' = 'industry_forecourt',
}

export type ImageMetaMapType = LangMap<
  Partial<Record<META_TRANSLATIONS, string>>
>;
